<app-import-progress-banner />

<!-- Toast notifications -->
<p-toast>
	<ng-template let-message pTemplate="message">
		<div style="display: flex; align-items: flex-start; gap: 0.75rem; width: 100%">
			<i
				[class]="
					'pi pi-' + (message.severity === 'success' ? 'check-circle' : message.severity === 'info' ? 'info-circle' : message.severity === 'warn' ? 'exclamation-triangle' : 'times-circle')
				"
				style="font-size: 1.5rem; margin-top: 0.25rem"
			></i>
			<div style="flex: 1">
				<div style="font-weight: 600; margin-bottom: 0.5rem">{{ message.summary }}</div>
				<div [innerHTML]="message.detail"></div>
			</div>
		</div>
	</ng-template>
</p-toast>

<!-- Custom toast to display update notice-->
<p-toast key="reload" [breakpoints]="{ '920px': { width: '100%', right: '0', top: '0', left: '0' } }">
	<ng-template pTemplate="message" let-message>
		<div class="update-toast-content">
			<div class="toast-header">Update available</div>
			<div>A new version of the application is available. Please reload to get the new version.</div>
			<p-button label="Reload" (onClick)="updateService.reloadApplication()" data-testid="app-reload-button" />
		</div>
	</ng-template>
</p-toast>

<app-navigation-header />

@if (!!(authService.userData$ | async)?.sessionID) {
	<app-sidebar [navigationItems]="navigationHeader?.navigationItems() ?? []" [environments]="navigationHeader?.environments() ?? []" />

	<div class="main-content" [class.sidebar-expanded]="sidebar?.sidebarVisible()">
		<router-outlet />
	</div>
} @else {
	<div class="sign-in">
		<p-card class="sign-in-card">
			@if (isProcessingAuthentication()) {
				<div class="sign-in-loading">
					<p-progressSpinner />
				</div>
			} @else {
				<p class="sign-in-message">Welcome to Analyzer. Please sign in to continue.</p>
				<p-button icon="pi pi-sign-in" label="Sign in" (onClick)="authService.login()" data-testid="app-sign-in-button" />
			}
		</p-card>
	</div>
}

<!-- First-login prompt inviting the user to set up a personal Jira access token (once per login). -->
<tmt-jira-token-prompt [visible]="jiraTokenPromptVisible()" (create)="onJiraPromptCreate()" (dismiss)="onJiraPromptDismiss($event.persist)" />
